// extracted by mini-css-extract-plugin
export default {"table-container":"KUnR275vKPoEALg6KpsU","table-top-right-field":"sP3Yp1wT0TAmzhvDUmhD","table-wrapper":"dExig9Z4Q8sqQyGUIxaa"};